<template>
  <footer class="border-t border-gray-200 dark:border-white/[0.06] bg-gray-50 dark:bg-dark py-16 transition-colors duration-300">
    <div class="container mx-auto px-4">
      <div class="grid grid-cols-1 md:grid-cols-4 gap-10 mb-12">
        <div class="md:col-span-1">
          <img src="/ciobai_logo_long.png" alt="Ciobai Logo" class="h-5 dark:brightness-0 dark:invert mb-4" />
          <p class="text-sm text-gray-500 dark:text-gray-600 leading-relaxed mb-4 transition-colors duration-300">
            {{ t('footer.company.description') }}
          </p>
          <div class="space-y-1.5 text-sm text-gray-500 dark:text-gray-600 transition-colors duration-300">
            <p>
              <a :href="'mailto:' + emailAddress" class="hover:text-gray-900 dark:hover:text-white transition-colors">{{ emailAddress }}</a>
            </p>
            <p>Bellinzona, Ticino, CH</p>
          </div>
        </div>
        
        <div>
          <h3 class="text-[13px] uppercase tracking-[0.15em] text-gray-400 dark:text-gray-500 font-medium mb-4">{{ t('nav.solutions') }}</h3>
          <ul class="space-y-2.5">
            <li v-for="(link, i) in solutionLinks" :key="i">
              <router-link :to="link.href" class="text-sm text-gray-500 dark:text-gray-600 hover:text-gray-900 dark:hover:text-white transition-colors">
                {{ link.text }}
              </router-link>
            </li>
          </ul>
        </div>

        <div>
          <h3 class="text-[13px] uppercase tracking-[0.15em] text-gray-400 dark:text-gray-500 font-medium mb-4">{{ t('nav.company') }}</h3>
          <ul class="space-y-2.5">
            <li><router-link to="/" class="text-sm text-gray-500 dark:text-gray-600 hover:text-gray-900 dark:hover:text-white transition-colors">{{ t('nav.home') }}</router-link></li>
            <li><router-link to="/chatbot-ticino" class="text-sm text-gray-500 dark:text-gray-600 hover:text-gray-900 dark:hover:text-white transition-colors">{{ t('nav.chatbotTicino') }}</router-link></li>
            <li><router-link to="/contact" class="text-sm text-gray-500 dark:text-gray-600 hover:text-gray-900 dark:hover:text-white transition-colors">{{ t('nav.contact') }}</router-link></li>
          </ul>
        </div>

        <div>
          <h3 class="text-[13px] uppercase tracking-[0.15em] text-gray-400 dark:text-gray-500 font-medium mb-4">{{ t('footer.resources.title') }}</h3>
          <ul class="space-y-2.5">
            <li><router-link to="/#benefits" class="text-sm text-gray-500 dark:text-gray-600 hover:text-gray-900 dark:hover:text-white transition-colors">{{ t('nav.benefits') }}</router-link></li>
            <li><router-link to="/#process" class="text-sm text-gray-500 dark:text-gray-600 hover:text-gray-900 dark:hover:text-white transition-colors">{{ t('nav.process') }}</router-link></li>
            <li><router-link to="/#use-cases" class="text-sm text-gray-500 dark:text-gray-600 hover:text-gray-900 dark:hover:text-white transition-colors">{{ t('nav.useCases') }}</router-link></li>
          </ul>
        </div>
      </div>
      
      <div class="border-t border-gray-200 dark:border-white/[0.06] pt-8 transition-colors duration-300">
        <p class="text-[13px] text-gray-400 dark:text-gray-700">
          {{ t('footer.copyright', { year: new Date().getFullYear() }) }}
        </p>
      </div>
    </div>
  </footer>
</template>

<script setup>
import { useI18n } from 'vue-i18n'
import { computed } from 'vue'

const { t } = useI18n()

const solutionLinks = computed(() => [
  { href: '/chatbot', text: t('solutions.links.chatbots') },
  { href: '/website', text: t('solutions.links.websites') },
  { href: '/#voice-agents', text: t('solutions.links.voiceAgents') },
  { href: '/automazioni-ai', text: t('solutions.links.processAutomation') }
])

const emailAddress = computed(() => 'alex@ciobai.ch')
</script>
